<template>
  <transition name='fade'>
    <div v-show='visible' :class='position' class='toast' @click="callback">
      <!--<div class="title">
        消息提示
        <i class="close" @click="close"> × </i>
      </div>-->
      <div class="message-panel">
        {{message}}
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        message: '',
        position: ''
      };
    },
    methods: {
      close () {
        this.visible = false;
      },
      callback () {
        this.visible = false;
        this.callback();
      }
    }
  };
</script>

<style lang="scss">
  .toast {
    position: fixed;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    word-wrap: break-word;
    z-index: 9999;
    font-size: 14px;
    border-radius: 5px;
    overflow: hidden;
    background-color: #00ccff;
    min-width: 380px;

    .title{
      color: #fff;
      font-size: 14px;
      height: 23px;
      line-height: 23px;
      padding: 0 17px;
      .close{
        float: right;
        width: 25px;
        margin-right: -10px;
        font-style: normal;
        cursor: pointer;
        font-size: 20px;
        text-align: center;
      }
    }
    .message-panel{
      background-color: #fff;
      border-radius: 5px;
      margin: 5px;
      margin-top: 0;
      padding: 10px;
      i{
        font-style: normal;
      }
    }

    &.fade-enter-active,
    &.fade-leave-active {
      transition: transform .2s
    }

    &.middle {
      top: 50%;

      &.fade-enter,
      &.fade-leave-active {
        transform: translate(-50%, -50%) scale(0);
      }
    }

    &.top {
      top: 80px;

      &.fade-enter,
      &.fade-leave-active {
        transform: translate(-50%, -110%) scale(0);
      }
    }

    &.bottom {
      top: 90%;

      &.fade-enter,
      &.fade-leave-active {
        transform: translate(-50%, 300px) scale(0);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue